"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const insights_1 = require("../insights");
const accent = '#4abfff';
exports.theme = extendTheme_1.extendTheme(insights_1.theme, {
    name: 'insightsDark',
    userFriendlyName: 'Insights Dark',
    dark: true,
    colors: {
        primary: '#13191d',
        primaryText: '#999',
        primaryDark: '#333',
        muted: '#333',
        success: '#87c144',
        info: 'rgb(70, 120, 200)',
        warning: '#daa520',
        online: '#87c144',
        accent: accent,
        selected: accent,
        accentBackgroundedText: '#FFF',
        pageText: '#fff',
        pageBackground: '#1e272e',
        cardBackground: '#13191d',
        cardText: '#AAA',
        floorplans: {
            area: {
                background: '#555',
                border: '#555',
            },
            furniture: {
                background: '#777',
                border: '#777',
                desk: {
                    background: '#888',
                    border: '#888',
                },
            },
        },
        charts: {
            primary: '#4bcffa',
            min: '#9ba1a7',
            neutral: '#485460',
            max: '#ff5e57',
            intervalShade: '#192934',
        },
    },
});
//# sourceMappingURL=index.js.map